export default {
	users_index: ({ users_index }) => {
		return users_index;
	},
};
